import { useCallback } from 'react';
import { Container, Row } from 'react-bootstrap';
import { useConvocatoria } from '../../appStore/convocatoria';
import LoadingText from '../CompUtils/LoadingText';
import { ConcursoPublicoCard } from './ConcursoPublicoCard';
import { Filtros } from './Filtros';

export const Concursos = () => {
  const { concursosPublicos, filtrados, loading } = useConvocatoria();

  const renderConcursos = useCallback(() => {
    const lista = Array.isArray(filtrados) ? filtrados : concursosPublicos;

    if (!Array.isArray(lista)) return null;

    const ordenados = [...lista].sort((a, b) => b.idLlamadoConcurso - a.idLlamadoConcurso);

    return ordenados.map((el) => <ConcursoPublicoCard key={el.idLlamadoConcurso} {...el} />);
  }, [filtrados, concursosPublicos]);

  return (
    <>
      <h2 className="text-center">Concursos publicados</h2>
      <Container>
        <Filtros />
      </Container>
      <br />
      <LoadingText show={loading} message="Buscando concursos publicados..." />
      <Row>{renderConcursos()}</Row>
    </>
  );
};
